<template>
  <div class="gp_base-select" :class="[className, 'position-' + popupDirection, { initiating: initiating }, { disabled: !options || options.length < 1 || disabled }]" v-clickaway="closeDropdown" @focus.prevent="focus">
    <select :name="name" :id="id" :disabled="disabled" :form="form" :multiple="multiple" :required="required" class="gp_base-select_model">
      <option :key="item.value" v-for="item in options">{{ item.text }}</option>
    </select>
    <template v-if="multiple">
      <div class="gp_base-select_container" :class="cclass">
        <div class="gp_base-select_display_hidden paragraph-14-16-regular text-light-high">{{ longestContent }}</div>
        <div class="gp_base-select_display noselect" :class="[{ disabled: !options || options.length <= 1 }, { active: opening }, { 'hide-arrow': !arrow }]" @click="toggleDropdown" ref="inputBounder" tabindex="0">{{ selectedText }}</div>
        <!-- <transition :name="initiating ? '' : 'drop' + popupDirection"> -->
        <TransitionExpand :name="animate ? 'expand' : ''">
          <div class="gp_base-select_dropdown" v-if="opening" ref="dropContain" :style="initiating ? 'z-index: -999; opacity: 0' : ''">
            <PerfectScrollbar class="scrollBody">
              <div class="gp_base-select_dropdown_item noselect" :class="{ active: val.indexOf(option.value) > -1 }" v-for="(option, index) in options" :key="option.value + '' + index" @click="updateValue(option.value)">
                <p class="paragraph-14-16-regular text-light-high">{{ option.text }}</p>
              </div>
            </PerfectScrollbar>
          </div>
        </TransitionExpand>
        <!-- </transition> -->
      </div>
    </template>

    <template v-else>
      <div class="gp_base-select_container" :class="cclass">
        <div class="gp_base-select_display_hidden paragraph-14-16-regular text-light-high">{{ longestContent }}</div>
        <div class="gp_base-select_display noselect" :class="[{ disabled: !options || options.length < 1 || disabled }, { active: opening }, { disabledHover: disabledHover },{ 'reverse-arrow': reverseArrow }, { 'hide-arrow': !arrow }]" @click="!disabled ? toggleDropdown() : null" ref="inputBounder" tabindex="0">
          <p class="gp_base-select_display-selected paragraph-14-16-regular text-light-high" :class="textClass" v-html="selectedText"></p>
          <Indicating v-if="indicating" iClass="gp-input-indicating" />
        </div>
        <TransitionExpand :name="animate ? 'expand' : ''">
          <div class="gp_base-select_dropdown" v-if="opening" ref="dropContain" :style="initiating ? 'z-index: -999; opacity: 0' : ''">
            <PerfectScrollbar class="scrollBody">
              <div class="gp_base-select_dropdown_item noselect" :class="{ active: option.value === selected }" v-for="(option, index) in options" :key="option.value + '' + index" @click="updateValue(option.value)">
                <p class="paragraph-14-16-regular text-light-high" :class="textClass" v-html="option.text"></p>
              </div>
            </PerfectScrollbar>
          </div>
        </TransitionExpand>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "BaseSelect",
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    cclass: String,
    textClass: {
      type: String,
      default: ''
    },
    animate: {
      type: Boolean,
      default: false
    },
    defaultText: {
      type: String,
      default: "generals.none"
    },
    defaultSelectedValue: String,
    id: {
      type: [String, Number, Boolean],
      default: false
    },
    name: {
      type: [String, Number, Boolean],
      default: false
    },
    form: {
      type: [String, Number, Boolean],
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: false,
      default() {
        return [
          {
            text: "generals.none",
            value: "none"
          }
        ];
      }
    },
    value: {
      type: [String, Number, Array],
      default: ""
    },
    disabled: {
      type: Boolean,
      required: false,
      default() {
        return false;
      }
    },
    positioning: {
      type: Boolean,
      default: false
    },
    arrow: {
      type: Boolean,
      default: true
    },
    disabledHover: {
      type: Boolean,
      default: false
    },
    className: String,
    defaultDirection: {
      type: String,
      default: "down"
    },
    indicating: {
      type: Boolean,
      default: false
    },
    reverseArrow: {
      type: Boolean,
      default: false
    },
    isSort: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: "",
      opening: false,
      selected: "none",
      backup: [],
      inVP: true,
      elHeight: 0,
      initiating: false,
      defaultValue: '',
    };
  },
  computed: {
    popupDirection() {
      if (!this.positioning) return this.defaultDirection || "";
      if (this.inVP) {
        return "down";
      }
      return "up";
    },
    selectedText() {
      if (this.multiple) {
        let selected = [];
        this.options.forEach(opt => {
          if (this.val.indexOf(opt.value) > -1) selected.push(opt.text);
        });
        if (selected.length) return selected.join(", ");
        return this.$t(this.defaultText);
      } else {
        if (this.defaultValue !== '') {
          return this.$t(this.defaultText);
        }
        let item = this.options.find(item => item.value == this.selected);
        if (item) {
          if (item.value == "") {
            return this.$t(this.defaultText);
          }
          if (this.isSort) {
            return `Sort: ${item.text}`
          }
          return item.text;
        }
        return this.$t(this.defaultText);
      }
    },
    longestContent() {
      if (this.options && this.options.length) {
        let max = "";

        this.options.forEach(item => {
          if (item.text.length > max.length) max = item.text;
        });
        if (this.multiple) {
          return max + ", additional";
        }
        return max;
      }
      return this.$t(this.defaultText);
    }
  },
  watch: {
    value(newV, oldV) {
      this.defaultValue = '';
      if (oldV === newV) return;
      this.setValue(newV);
    },
    opening: {
      immediate: true,
      handler() {
        if (this.$refs && this.$refs.dropContain) this.elHeight = this.$refs.dropContain.getBoundingClientRect().height;
      }
    },
    elHeight() {
      this.autoPosition();
    }
  },
  created() {
    this.$emit("created", this);
    if (this.defaultSelectedValue) {
      this.defaultValue = this.defaultSelectedValue;
      this.setValue(this.defaultValue);
    } else {
      this.setValue(this.value);
    }

    window.addEventListener("scroll", this.autoPosition);
    window.addEventListener("mousewheel", this.autoPosition);
    window.addEventListener("ps-scroll-y", this.autoPosition);
    window.addEventListener("resize", this.autoPosition);
    this.initFirst();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.autoPosition);
    window.removeEventListener("mousewheel", this.autoPosition);
    window.removeEventListener("ps-scroll-y", this.autoPosition);
    window.removeEventListener("resize", this.autoPosition);
  },
  methods: {
    autoPosition() {
      setTimeout(() => {
        if (!this.$refs) return;
        if (!this.$refs.inputBounder) return;
        if (this.$refs.dropContain) {
          this.elHeight = this.$refs.dropContain.getBoundingClientRect().height;
        }
        let viewportTop = window.pageYOffset,
          viewportBottom = window.pageYOffset + window.document.documentElement.clientHeight,
          rect = this.$refs.inputBounder.getClientRects()[0],
          elementTop = rect.top,
          elementBottom = rect.bottom;
        if (elementBottom + this.elHeight <= viewportBottom) {
          this.inVP = true;
          return;
        }
        if (elementTop - this.elHeight >= viewportTop + 60) {
          this.inVP = false;
          return;
        }
        this.inVP = true;
      }, 100);
    },
    initFirst() {
      this.initiating = true;
      this.toggleDropdown();
      this.$nextTick(() => {
        this.autoPosition();
        this.toggleDropdown();
        this.initiating = false;
      });
    },
    // Dropdown Controlling
    toggleDropdown() {
      // this.backup = JSON.parse(JSON.stringify(this.val));
      if (this.options && this.options.length >= 1) this.opening = !this.opening;
      if (!this.opening) {
        // this.elHeight = 0
        if (this.$refs && this.$refs.dropContain) this.elHeight = this.$refs.dropContain.getBoundingClientRect().height;
      }
    },
    closeDropdown() {
      if (this.opening) {
        this.blur();
        this.opening = false;
        if (this.multiple) {
          if (this.val && this.val.length)
            if (this.backup.join(",") != this.val.join(",")) {
              this.backup = this.val;
              this.change();
            }
        }
      }
    },
    // Base
    updateValue(value) {
      if (this.multiple) {
        if (!Array.isArray(this.val)) {
          this.val = [];
        }
        let index = this.val.findIndex(opt => opt === value);
        if (index > -1) this.val.splice(index, 1);
        else this.val.push(value);
        this.onChange();
      } else {
        let updated = this.setValue(value);
        if (updated) this.change();
        if (this.opening) this.opening = false;
      }
    },
    setValue(value) {
      if (this.multiple) {
        this.selected = value;
        this.val = value;
        return true;
      } else {
        if (value != this.val) {
          this.selected = value;
          this.val = value;
          return true;
        }
        return false;
      }
    },
    onChange() {
      this.$emit("input", this.val);
      // this.$emit("onChange", this.id, this.val);
    },
    change() {
      this.$emit("input", this.val);
      this.$emit("change", this.id, this.val);
    },
    focus() {
      this.$emit("focus", this.id, this.val);
    },
    blur() {
      this.$emit("blur", this.id, this.val);
    }
  }
};
</script>

<style lang="scss" scoped>
$blue: #839bc0;
$text: #333333;
$textShade2: #7f7f7f;
$textShade3: #dadada;

@mixin new-dropdown() {
  left: auto;
  padding: 8px;
  top: 48px !important;
  box-shadow: 0px -2px 8px rgba(0, 0, 0, 0.06), 0px 2px 8px rgba(0, 0, 0, 0.12);
  .scrollBody {
    border-radius: 3px;
  }
  &_item {
    display: flex;
    justify-content: flex-start;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    padding-left: 35px !important;
    border-left: none !important;
    border-radius: 3px;
    > p {
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      text-overflow: inherit !important;
      overflow: hidden !important;
      -webkit-line-clamp: inherit !important;
    }
    &.active {
      position: relative;
      background: none !important;
      &:before {
        content: "\e970";
        position: absolute;
        left: 8px;
        top: 10px;
        width: 16px;
        height: 16px;
        font-size: 16px;
        display: inline-block;
        font-family: "gemicon" !important;
        color: #00C853;
      }
      &:hover {
        background: $light2 !important;
      }
    }
    &:hover {
      background-color: $light2;
    }
  }
}


.gp-settings-page {
  .gp_base-select {
    border: 1px solid $textDarkModeHigh;
  }
  .scrollBody {
    max-height: 280px;
  }
}

.eventlog {
  .gp_base-select_display {
    padding-left: 0 !important;
    white-space: nowrap;
    width: auto;
    &_hidden {
      display: none !important;
    }
    &:not(.hide-arrow) {
      &:after {
        display: flex !important;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        right: 10px !important;
      }
    }
  }
  .gp_base-select_dropdown {
    width: 258px !important;
    border-radius: 0px !important;
  }
}

.page-list {
  .gp_base-select_display {
    white-space: nowrap;
    width: auto;
    border-radius: 3px;
    border: solid 1px $neutral7;
    padding: 11px 40px 11px 7px !important;
    &:focus {
      background: $light1;
      border: solid 1px $mono3;
    }
    &:after {
      color: $dark6 !important;
    }
  }
  .gp_base-select_dropdown {
    top: 44px !important;
    .scrollBody {
      border-radius: 3px;
    }
    &_item {
      padding: 12px !important;
      border-left: none !important;
      &.active {
        position: relative;
        &:after {
          content: "\e907";
          position: absolute;
          right: 12px;
          top: 9px;
          font-size: 16px;
          display: inline-block;
          font-family: "gemicon" !important;
          color: $mono3;
        }
      }
      &:hover {
        background-color: $light3;
      }
    }
  }
}
.gp_base-select_model {
  display: none;
}
.ps > .ps__scrollbar-y-rail {
  right: -11px !important;
}
.gp_base-select {
  label {
    display: block;
  }
  .gp_base-select_container {
    position: relative;
    // min-width: 360px;
    display: flex;
    flex-direction: column;
  }
  .gp_base-select_display {
    position: relative;
    display: flex;
    flex: 1;
    outline: none;
    text-overflow: ellipsis;
    // -webkit-appearance: menulist;
    padding: 10px 40px 11px 16px;
    height: 40px;
    max-height: 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    border: solid 1px transparent;
    border-radius: 3px;
    @include trans-all;

    &:not(.disabled):not(.disabledHover):hover {
      .gp_base-select_display-selected {
        color: $mono3 !important;
      }
      &:after {
        color: $mono3;
      }
    }

    p {
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      display: block !important;
      display: -webkit-box !important;
      overflow: hidden;
      white-space: normal;
    }

    //new
    flex: 1;
    overflow: hidden;
    // border: none;

    &.disabled {
      cursor: default;
    }

    &:disabled {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }

    &:not(.hide-arrow) {
      &:after {
        content: "\e90f";
        position: absolute;
        right: 12px;
        top: 9px;
        display: inline-block;
        font-family: "gemicon" !important;
        @include trans-all;
      }
      &.active:after {
        transform: rotate(180deg);
      }

      &.reverse-arrow {
        &:after {
          content: "\e90f";
          position: absolute;
          right: 12px;
          top: 9px;
          display: inline-block;
          font-family: "gemicon" !important;
          @include trans-all;
          transform: rotate(180deg);
        }
        &.active:after {
          transform: rotate(0deg);
        }
      }
    }
  }

  .gp_base-select_display_hidden {
    display: flex;
    padding: 0px 40px 0px 16px;
    height: 0px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
  }
  .gp_base-select_dropdown {
    position: absolute;
    top: 40px;
    left: 0px;
    right: 0px;
    width: 100%;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0px 0.332071px 0.719487px rgba(0, 0, 0, 0.0168687), 0px 0.798012px 1.72903px rgba(0, 0, 0, 0.0242336), 0px 1.50259px 3.2556px rgba(0, 0, 0, 0.03), 0px 2.68036px 5.80744px rgba(0, 0, 0, 0.0357664), 0px 5.01331px 10.8622px rgba(0, 0, 0, 0.0431313), 0px 12px 26px rgba(0, 0, 0, 0.06);
    z-index: 12;
    min-width: 80px;

    // new
    // box-shadow: 0 0 10px 0px #8a8a8a;
  }
  .gp_base-select_dropdown_item {
    padding: 11px 16px;
    text-align: left;
    transition: all 0.3s;
    background: $light1;
    cursor: pointer;
    border-left: 3px solid $light1;
    min-height: 40px;

    &.default-option {
      min-height: 50px;
    }

    p {
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      display: block !important;
      display: -webkit-box !important;
      overflow: hidden;
      white-space: normal;
    }

    &:not(.active):hover {
      background-color: $light2;
      border-left: 3px solid $light2;
    }
    &.active {
      background-color: $light2;
      border-left: 3px solid $textLightModeHigh;
    }
  }

  &.position-up &_dropdown {
    top: unset;
    bottom: calc(100%);
  }
  &.position-up &_display:not(.hide-arrow):after {
    transform: rotate(180deg);
  }
  &.position-up &_display.active:not(.hide-arrow):after {
    transform: rotate(0deg);
  }
  &.disabled {
    opacity: 0.6;
  }
}
.gp-indicating {
  margin-left: auto;
}
.scrollBody {
  height: auto !important;
}

.base-select__new {
  width: min-content !important;
  .gp_base-select_display {
    white-space: nowrap !important;
    width: fit-content;
    border-radius: 3px;
    padding: 11px 40px 11px 0px !important;
    border: none !important;
    &-label {
      display: none !important;
    }
    > p {
      font-size: 12px;
      line-height: 150%;
      font-weight: 500;
      color: $textLightModeHigh;
      white-space: nowrap !important;
    }

    &:after {
      display: flex !important;
      align-items: center;
      height: 12px;
      top: 14px !important;
      color: inherit !important;
    }
    
    &:not(.disabled):not(.disabledHover):hover {
      &:after {
        color: inherit !important;
      }
      p {
        color: inherit !important;
      }
      .gp_base-select_display-selected {
        color: inherit !important;
      }
    }

    &_hidden {
        padding: 0px !important;
    }

    &.border {
      border: none !important;
    }
    &.reverse-arrow {
      &:after {
        color: $dark6 !important;
      }
    }
  }
  .gp_base-select_dropdown {
    width: max-content !important;
    @include new-dropdown;
  }
}

.new-dropdown-select {
  .gp_base-select_display {
    border: solid 1px $neutral7;
    &:not(.disabled):not(.disabledHover):hover {
      border: solid 1px $dark8;
      &:after {
        color: inherit !important;
      }
      p {
        color: inherit !important;
      }
      .gp_base-select_display-selected {
        color: inherit !important;
      }
    }
  }
  .gp_base-select_dropdown {
    @include new-dropdown;
  }
}
.font-normal {
  font-weight: 400 !important
}
</style>
